import { render, staticRenderFns } from "./PaginationSummary.vue?vue&type=template&id=4b4eea20&scoped=true"
import script from "./PaginationSummary.vue?vue&type=script&lang=js"
export * from "./PaginationSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4eea20",
  null
  
)

export default component.exports